// downloadBlob — trigger a browser download of a Blob (object URL → anchor click →
// revoke). The one DOM dance, shared by the ExportDialog and the import wizard's
// template / current-data / error-file downloads — so it lives in exactly one
// place instead of being re-copied per consumer. A body the SERVER named (a `File`
// off `content-disposition` — the day in the export's zone, ADR-082 §8) keeps that
// name; the caller's `filename` is the stem for a body it built itself.
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = blob instanceof File ? blob.name : filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
